/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EmailTemplateGroup {
  Basic = "basic",
  Leads = "leads",
  GettingStarted = "getting_started",
  Accounts = "accounts",
  Quoting = "quoting",
  Booking = "booking",
  Tracking = "tracking",
  GeneralInfo = "general_info",
  Reengage = "reengage",
  Finance = "finance",
}

export function instanceOfEmailTemplateGroup(value: any): boolean {
  for (const key in EmailTemplateGroup) {
    if (Object.prototype.hasOwnProperty.call(EmailTemplateGroup, key)) {
      if (
        EmailTemplateGroup[key as keyof typeof EmailTemplateGroup] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EmailTemplateGroupFromJSON(json: any): EmailTemplateGroup {
  return EmailTemplateGroupFromJSONTyped(json, false);
}

export function EmailTemplateGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailTemplateGroup {
  return json as EmailTemplateGroup;
}

export function EmailTemplateGroupToJSON(
  value?: EmailTemplateGroup | null,
): any {
  return value as any;
}

export function EmailTemplateGroupToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EmailTemplateGroup {
  return value as EmailTemplateGroup;
}
